import "core-js/modules/es.array.find.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.trim.js";
import { listWineTypes, casingWines } from "@/js/lists.ts";
export function wineNaming(whitelabelconfig, wineNamingData, isPrefixWinery, isSuffixBottling) {
  var isSuffixType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
  var stringReturn = "";
  if (isPrefixWinery && whitelabelconfig.isMultipleWineries) {
    stringReturn += wineNamingData.winery + ", ";
  }
  var isSparkling = wineNamingData.wine_type === listWineTypes.find(function (x) {
    return x.name === "Sparkling";
  }).id;
  var isSpirit = wineNamingData.wine_type === listWineTypes.find(function (x) {
    return x.name === "Spirit";
  }).id;
  if (whitelabelconfig.namingWineTemplate == "default") {
    if (isSpirit) {
      stringReturn += wineNamingData.cuvee.trim() + " ";
    } else if (isSparkling) {
      stringReturn += wineNamingData.appellation.toUpperCase() != "CHAMPAGNE" ? wineNamingData.appellation.trim() + " " : "";
      stringReturn += wineNamingData.cuvee ? wineNamingData.cuvee.trim() + " " : "";
      stringReturn += wineNamingData.dosage ? wineNamingData.dosage.trim() + " " : "";
      stringReturn += wineNamingData.classification ? wineNamingData.classification.trim() + " " : "";
    } else {
      stringReturn += wineNamingData.appellation ? wineNamingData.appellation.trim() + " " : "";
      stringReturn += wineNamingData.dosage ? wineNamingData.dosage.trim() + " " : "";
      stringReturn += wineNamingData.classification ? wineNamingData.classification.trim() + " " : "";
      if (wineNamingData.denomination || wineNamingData.cuvee) {
        stringReturn += '"';
        if (wineNamingData.denomination && wineNamingData.cuvee) {
          stringReturn += wineNamingData.denomination.trim() + " - " + wineNamingData.cuvee.trim();
        } else {
          stringReturn += wineNamingData.denomination ? wineNamingData.denomination.trim() : wineNamingData.cuvee.trim();
        }
        stringReturn += '" ';
      }
    }
  } else if (whitelabelconfig.namingWineTemplate == "pabus") {
    if (wineNamingData.cuvee) {
      stringReturn += wineNamingData.cuvee + " ";
      stringReturn += wineNamingData.vintage ? wineNamingData.vintage + " " : "";
    } else {
      switch (wineNamingData.wine_type) {
        case 1:
          //RedWine
          stringReturn += wineNamingData.winery + " ";
          stringReturn += wineNamingData.classification ? wineNamingData.classification.trim() + " " : "";
          break;
        default:
          stringReturn += wineNamingData.appellation ? wineNamingData.appellation.trim() + " " : "";
          stringReturn += wineNamingData.classification ? wineNamingData.classification.trim() + " " : "";
      }
    }
  }
  stringReturn += wineNamingData.vintage ? wineNamingData.vintage + " " : "";
  stringReturn = stringReturn.trim();
  if (isSuffixBottling) {
    stringReturn += " " + wineNamingData.bottling;
  }
  if (isSuffixType) {
    stringReturn += " " + listWineTypes.find(function (x) {
      return x.id === wineNamingData.wine_type;
    }).name;
  }
  return stringReturn;
}
export function casingForAdmin() {
  return {
    casingId: "OC1",
    quantity: 1,
    isDefault: false,
    textCard: casingWines.find(function (x) {
      return x.value == "OC1";
    }).textCard
  };
}